import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
class ApprovedBadgesList extends Component {
    state = {
        item: {}
    };

    render() {
        return (
            <Fragment>
                <tr>
                    <td>{this.props.item.id}</td>
                    <td>
                        {this.props.item.user.first_name}{" "}
                        {this.props.item.user.last_name}
                    </td>
                    <td>{this.props.item.user.email}</td>
                    <td>
                        <img
                            style={{ width: 32 }}
                            src={this.props.item.user.image}
                            alt={this.props.item.user.name}
                        ></img>
                    </td>
                </tr>
            </Fragment>
        );
    }
}
ApprovedBadgesList.contextType = AppContext;
export default ApprovedBadgesList;



// WEBPACK FOOTER //
// ./src/components/admin/adminBadges/ApprovedBadgesList.js